<template>
  <v-card
    style="border-radius: 0 !important;"
    @keyup.enter="doLogin"
  >
    <v-card-title
      class="justify-center text-center primary--text display-3 font-weight-thin mb-5"
    >
      <img v-bind:src="logo()" width="200" />
    </v-card-title>
    <v-card-text>
      <v-text-field
        id="email"
        v-model="identity"
        outlined
        type="email"
        label="Email"
        dense
      />
      <v-text-field
        id="password"
        v-model="password"
        outlined
        type="password"
        label="Password"
        hide-details
        dense
      />

      <v-divider class="my-5" />

      <v-btn
        block
        color="primary"
        class="white--text"
        :loading="isLoading"
        @click="doLogin"
      >
        Login
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  components: {},
  watch: {
    'getMyTenants': function() {
      console.log('my tenants changed', this.getMyTenants.length, this.getMyTenants)

      const numTenants = this.getMyTenants.length

      if (this.getUserTenants.length === 0) {
        this.logout();
      } else if(numTenants === 1) {
        this.changeSession(this.getMyTenants[0].id)

      } else if(numTenants > 1) {
        this.setSessionDialog(true)
      }
    }
  },
  computed: {
    ...mapGetters(['getMyTenants', 'getUserTenants'])
  },
  data() {
    return {
      isLoading: false,
      identity: '',
      password: ''
    }
  },
  methods: {
    ...mapActions([ 'login', 'setSessionDialog', 'logout', 'changeSession' ]),
    doChangeSession() {

    },
    doAskSession() {

    },
    doLogin() {
      this.isLoading = true

      const payload = {
        identity: this.identity,
        password: this.password
      }
      this.login(payload)
        .catch()
        .finally(() => { this.isLoading = false })
    },
    logo() {
      return require(`@/assets/themes/dcms/logo.png`)
    }
  }
}
</script>
